















































































import Vue from "vue";

// Vuex
import { RootState } from "@/store";
import { mapState } from "vuex";

// vue components
import ChartBar from "./ChartsCard/ChartBar.vue";
import Number from "./ChartsCard/Number.vue";
import TableCard from "./ChartsCard/TableCard.vue";
import ChartLine from "./ChartsCard/ChartLine.vue";
import ChartColumn from "./ChartsCard/ChartColumn.vue";
import ChartPie from "./ChartsCard/ChartPie.vue";
import ChartRadar from "./ChartsCard/ChartRadar.vue";
import ChartTimeLineComponent from "./ChartsCard/ChartTimeLine.vue";
import ChartHeadtGrid from "./ChartsCard/ChartHeatGrid.vue";
import ChartStacked from "./ChartsCard/ChartStacked.vue";
import InstallationSummaryCard from "./ChartsCard/InstallationSummaryCard.vue";
import InstallationsStatusChangesTable from "./ChartsCard/InstallationsStatusChangesTable.vue";

// model
import { DashboardWidget } from "@/model/data/dashboard/DashboardWidget";
import { FetchDashboardWidgetDataCommand } from "@/model/communication/dashboard/widget/FetchDashboardWidgetDataCommand";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { WidgetViewTypesEnum } from "@/model/data/dashboard/WidgetViewTypesEnum";
import { Charts_Palette } from "@/utility/Constants";
import { UpdateDashboardWidgetCommand } from "@/model/communication/dashboard/widget/UpdateDashboardWidgetCommand";

export default Vue.extend({
    components: {
        Number,
        TableCard,
        ChartLine,
        ChartBar,
        ChartColumn,
        ChartPie,
        ChartRadar,
        ChartTimeLineComponent,
        ChartHeadtGrid,
        ChartStacked,
        InstallationSummaryCard,
        InstallationsStatusChangesTable,
    },
    data() {
        return {
            loading: false,
            widgetData: null,
        };
    },
    props: ["widget", "isPreview"],
    computed: {
        ...mapState({ tvMode: (s: RootState) => s.application.tvMode }),
        datasets() {
            let res = [];

            if (this.widgetData) {
                this.widgetData.series.forEach((serie, index) => {
                    let currentSet;
                    if ((this.widget as DashboardWidget).viewConfig.viewType == WidgetViewTypesEnum.PieChart)
                        currentSet = { label: serie.name, data: serie.values, backgroundColor: Charts_Palette };
                    else if ((this.widget as DashboardWidget).viewConfig.viewType == WidgetViewTypesEnum.RadarChart)
                        currentSet = { label: serie.name, data: serie.values, backgroundColor: Charts_Palette[index], borderColor: Charts_Palette[index] };
                    else currentSet = { label: serie.name, data: serie.values, backgroundColor: Charts_Palette[index] };

                    if (
                        (this.widget as DashboardWidget).viewConfig.viewType == WidgetViewTypesEnum.TimeLineChart ||
                        (this.widget as DashboardWidget).viewConfig.viewType == WidgetViewTypesEnum.LineChart
                    ) {
                        currentSet.fill = false;
                        currentSet.borderColor = Charts_Palette[index];
                    }

                    res.push(currentSet);
                });
            }

            return res;
        },

        currentComponent() {
            switch ((this.widget as DashboardWidget).viewConfig.viewType) {
                case WidgetViewTypesEnum.Number:
                    return Number;
                case WidgetViewTypesEnum.InstallationSummaryCard:
                    return InstallationSummaryCard;
                case WidgetViewTypesEnum.InstallationsStatusChangesTable:
                    return InstallationsStatusChangesTable;
                case WidgetViewTypesEnum.Table:
                    return TableCard;
                case WidgetViewTypesEnum.LineChart:
                    return ChartLine;
                case WidgetViewTypesEnum.BarChart:
                    return ChartBar;
                case WidgetViewTypesEnum.PieChart:
                    return ChartPie;
                case WidgetViewTypesEnum.RadarChart:
                    return ChartRadar;
                case WidgetViewTypesEnum.TimeLineChart:
                    return ChartTimeLineComponent;
                case WidgetViewTypesEnum.HeatGridChart:
                    return ChartHeadtGrid;
                case WidgetViewTypesEnum.ColumnChart:
                    return ChartColumn;
                case WidgetViewTypesEnum.StackedChart:
                    return ChartStacked;
                default:
                    return null;
            }
        },

        canDownload() {
            return (
                this.widget.viewConfig.viewType != WidgetViewTypesEnum.Number &&
                this.widget.viewConfig.viewType != WidgetViewTypesEnum.Table &&
                this.widgetData != null &&
                (this.widgetData.labels.length > 0 || this.widgetData.series.length > 0)
            );
        },
    },
    watch: {
        widget: {
            handler(newValue, oldValue) {
                if (!this.isPreview) this.updateWidget();

                // se il widget è cambiato, ricarico i dati
                if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) this.fetchWidgetData(null);
            },
            deep: true,
        },
    },
    methods: {
        async fetchWidgetData(widgetRef: DashboardWidget) {
            if (!this.loading) {
                this.loading = true;

                try {
                    let res;
                    if (widgetRef == null) res = await new FetchDashboardWidgetDataCommand(this.widget).execute();
                    else res = await new FetchDashboardWidgetDataCommand(widgetRef).execute();

                    if (res.responseStatus == ApiResponseStatusEnum.Success) {
                        this.widgetData = res.widgetData;
                    } else {
                        console.error("widget data res status is not success");
                    }

                    // imposto il timeout per il refresh automatico
                    if ((this.widget as DashboardWidget).refreshTimeout) {
                        setTimeout(this.fetchWidgetData, (this.widget as DashboardWidget).refreshTimeout * 1000);
                    }

                    this.loading = false;
                } catch (error) {
                    console.error("cannot fetch widget data:", error);
                    this.loading = false;
                }
            }
        },

        async updateWidget() {
            try {
                let res = await new UpdateDashboardWidgetCommand(this.widget, this.$vuetify.breakpoint.name).execute();

                if (res.responseStatus != ApiResponseStatusEnum.Success) {
                    console.error("Error trying update widget with id: ", this.widget.id);
                }
            } catch (error) {
                console.error("Error trying update widget with id: ", this.widget.id, " error: ", error);
            }
        },

        downloadChart() {
            console.log("downloadRequired");
            let a = document.createElement("a");
            a.href = this.$refs.chart.$refs.canvas.toDataURL("image/jpg");
            a.download = this.widget.title + ".png";
            a.click();
        },
    },
    mounted() {
        this.fetchWidgetData(null);
    },
});
